import { GiPokerHand } from 'react-icons/gi';
import { TiLockClosed } from 'react-icons/ti';
import { MenuItem } from '@/features/layout/types/layout.types';
import { PiPokerChipFill } from 'react-icons/pi';
import { IoIosTrophy } from 'react-icons/io';
import useIsMobileView from '../../hooks/useIsMobileView';
import HeaderDesktopDisplay from './views/HeaderDesktopDisplay';
import HeaderMobileDisplay from './views/HeaderMobileDisplay';
import { FC } from 'react';
import BREAKPOINTS from '@/common/constant/breakpoints';
import RoadmapIcon from '@/components/header/RoadmapIcon';

interface HeaderProps {
  showGoBackButton?: boolean;
}

const modeMenuOptions: MenuItem[] = [
  { title: 'Ring Games', Icon: GiPokerHand, comingSoon: false, selected: true, onClick: () => null },
  { title: 'Sit & Go', Icon: PiPokerChipFill, comingSoon: true, selected: false, onClick: () => null },
  { title: 'Tournament', Icon: IoIosTrophy, comingSoon: true, selected: false, onClick: () => null },
  { title: 'Private Room', Icon: TiLockClosed, comingSoon: true, selected: false, onClick: () => null },
  {
    title: 'Roadmap',
    Icon: RoadmapIcon,
    comingSoon: false,
    selected: false,
    onClick: () => window.open('/roadmap', '_blank'),
  },
];
const Header: FC<HeaderProps> = ({ showGoBackButton = false }) => {
  const isMobileView = useIsMobileView({ checkForUserAgent: false, breakpoint: BREAKPOINTS.xl });

  if (isMobileView) {
    return <HeaderMobileDisplay modeMenuOptions={modeMenuOptions} showGoBackButton={showGoBackButton} />;
  }
  return <HeaderDesktopDisplay modeMenuOptions={modeMenuOptions} />;
};

export default Header;
